// window.env is loaded by env.js, which is loaded by index.html. This is how the API_URL is set.
// For local dev it is located in public/env.js
// For production it is located in files in directory cloudformation

const config = {
  ...window.env
}

export default config
